import { store } from "./DataStore";
import connect from "@escapio/shared/data-store/connect";
import { render, nothing, html } from "lit-html";
import { translate } from "@escapio/shared/l10n/translate";

const otherNodesSelectors = [
	".hotel-list__controls",
	".hotel-list__sorting-mobile",
	".hotel-list__heading",
	".hotel-list__content",
];

/**
 * Error message when favorite list is empty.
 *
 * @author bgr
 */
customElements.define(
	"esc-favorites-empty-message",
	class extends connect(HTMLElement, store) {
		update(state, store) {
			if (store.isLoading || store.sortedHotels.length) {
				render(nothing, this);
				this.style.display = "none";
				otherNodesSelectors.forEach(
					selector => (document.querySelector(selector).style.display = ""),
				);
			} else {
				render(
					html`
						<div class="message message--colored form-element--top-spacing">
							<span class="fa fa-info bullit bullit--blue message__icon"></span>
							<div>${translate("list_favorites_empty_message_info")}</div>
						</div>
					`,
					this,
				);
				this.style.display = "block";
				otherNodesSelectors.forEach(
					selector => (document.querySelector(selector).style.display = "none"),
				);
			}
		}
	},
);
